import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cpu, AlertTriangle, Sparkles, Info } from 'lucide-react';

const AIUsageDisplay = ({ usage, onUpgrade }) => {
  const { t } = useTranslation();
  
  if (!usage) return null;
  
  const { count, limit, is_unlimited, percentage, plan } = usage;
  
  // Don't show for non-AI plans
  if (!['AI', 'AI_UNLIMITED'].includes(plan?.toUpperCase())) {
    return null;
  }
  
  // Unlimited plan
  if (is_unlimited) {
    return (
      <div className="flex items-center gap-2 text-sm text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-lg">
        <Sparkles className="w-4 h-4" />
        <span>AI Unlimited</span>
      </div>
    );
  }
  
  // Calculate warning state
  const isWarning = percentage >= 80;
  const isLimitReached = count >= limit;
  
  // Progress bar color
  const progressColor = isLimitReached 
    ? 'bg-red-500' 
    : isWarning 
      ? 'bg-amber-500' 
      : 'bg-blue-500';
  
  return (
    <div 
      className={`flex items-center gap-3 px-3 py-2 rounded-lg ${
        isLimitReached ? 'bg-red-50 border border-red-200' : 
        isWarning ? 'bg-amber-50 border border-amber-200' : 
        'bg-gray-50 border border-gray-200'
      }`}
      title="Crediti basati sulla complessità del disegno (1 credito per chiamata API). Disegno semplice ~3 crediti, complesso ~7+ crediti."
    >
      <Cpu className={`w-4 h-4 ${
        isLimitReached ? 'text-red-500' : 
        isWarning ? 'text-amber-500' : 
        'text-blue-500'
      }`} />
      
      <div className="flex flex-col min-w-[120px]">
        <div className="flex items-center justify-between text-xs mb-1">
          <span className={`font-medium ${
            isLimitReached ? 'text-red-700' : 
            isWarning ? 'text-amber-700' : 
            'text-gray-700'
          }`}>
            Crediti: {count} / {limit}
          </span>
          {isWarning && !isLimitReached && (
            <AlertTriangle className="w-3 h-3 text-amber-500" />
          )}
        </div>
        
        {/* Progress bar */}
        <div className="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div 
            className={`h-full ${progressColor} transition-all duration-300`}
            style={{ width: `${Math.min(100, percentage)}%` }}
          />
        </div>
      </div>
      
      {isLimitReached && onUpgrade && (
        <button
          onClick={onUpgrade}
          className="text-xs font-medium text-red-600 hover:text-red-700 underline whitespace-nowrap"
        >
          Upgrade
        </button>
      )}
    </div>
  );
};

export default AIUsageDisplay;
